"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MESSAGE_MODAL_BODY = exports.WARNING_MESSAGE = exports.SUCCESS_MESSAGE = exports.ERROR_MESSAGE = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const colors_1 = __importDefault(require("../../styles/colors"));
exports.ERROR_MESSAGE = 'error';
exports.SUCCESS_MESSAGE = 'success';
exports.WARNING_MESSAGE = 'warning';
const ERROR_MODAL_BODY = {
    title: 'Error',
    icon: free_solid_svg_icons_1.faTimesCircle,
    color: colors_1.default.RED,
};
const SUCCESS_MODAL_BODY = {
    title: 'Success',
    icon: free_solid_svg_icons_1.faCheckCircle,
    color: colors_1.default.GREEN,
};
const WARNING_MODAL_BODY = {
    title: 'warning',
    icon: free_solid_svg_icons_1.faExclamationCircle,
    color: colors_1.default.YELLOW,
};
exports.MESSAGE_MODAL_BODY = {
    [exports.SUCCESS_MESSAGE]: SUCCESS_MODAL_BODY,
    [exports.WARNING_MESSAGE]: WARNING_MODAL_BODY,
    [exports.ERROR_MESSAGE]: ERROR_MODAL_BODY,
};
